/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ programName: NonNullable<unknown> }} Week_Session_Manager_DescriptionInputs */

const fr_week_session_manager_description = /** @type {(inputs: Week_Session_Manager_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gestion des semaines d'entraînement pour ${i?.programName}`)
};

/**

* @param {Week_Session_Manager_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_manager_description = /** @type {((inputs: Week_Session_Manager_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Manager_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_manager_description(inputs)
});